import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { BasketLink } from '../BasketLink';

export interface OrderPrincipalCardDetailsProps {
  isMobile?: boolean;
  orderName: string;
  requestedAmount: string;
  orderDate: string;
  notificationChannels: string;
  orderHasBasket: boolean;
  assetCount?: number;
  clientCount?: number;
  onBasketPress?: () => void;
  onExportPress?: () => void;
  requestUserFullName?: string | null;
}

export const OrderPrincipalCardDetails: React.FC<OrderPrincipalCardDetailsProps> = ({
  isMobile,
  orderName,
  orderDate,
  requestedAmount,
  notificationChannels,
  orderHasBasket,
  onBasketPress,
  onExportPress,
  assetCount = 0,
  clientCount = 0,
  requestUserFullName,
}) => {
  const renderInfo = (title: string, info: string) => (
    <Stack
      space={Spacing['stack.quarck']}
      direction={isMobile ? 'row' : 'column'}
      justifyContent={isMobile ? 'space-between' : 'inherit'}>
      <UI.Text variant="semibold" color={isMobile ? 'neutral.medium' : 'neutral.darkest'}>
        {title}
      </UI.Text>
      <UI.Text color="neutral.black">{info}</UI.Text>
    </Stack>
  );

  if (isMobile) {
    return (
      <VStack
        p={Spacing['inset.sm']}
        space={Spacing['stack.nano']}
        bgColor={Utils.ColorToken.WithOpacity('brand.primary.lightest', 0.3)}
        borderRadius={BoxBorder.heavy}>
        <HStack justifyContent="space-between">
          <HStack space={Spacing['inline.xxxs']}>
            <UI.Text fontSize={Typography['fontsize.md']} variant="semibold">
              {orderName}
            </UI.Text>
            {!!orderHasBasket && <BasketLink onPress={onBasketPress} />}
          </HStack>
          <UI.IconButton
            testId="pdf-export"
            p={0}
            icon="Pdf"
            iconSize="xxs"
            iconColor={Color['brand.tertiary.principal']}
            onPress={onExportPress}
          />
        </HStack>
        {!!requestUserFullName && renderInfo('Enviado por', requestUserFullName)}
        {!!clientCount && renderInfo('Qtd. clientes', clientCount.toString())}
        {!!assetCount && renderInfo('Qtd. ativos', assetCount.toString())}
        {renderInfo('Valor enviado', requestedAmount)}
        {renderInfo('Data de envio', orderDate)}
        {renderInfo('Canal de envio', notificationChannels)}
      </VStack>
    );
  }

  return (
    <HStack
      p={Spacing['inset.xs']}
      bgColor={Utils.ColorToken.WithOpacity('brand.primary.lightest', 0.3)}
      borderRadius={BoxBorder.heavy}
      justifyContent="space-between">
      {renderInfo('Nome da ordem', orderName)}
      <Stack />
      {requestUserFullName ? renderInfo('Enviado por', requestUserFullName) : <Stack />}
      {clientCount ? renderInfo('Clientes', clientCount.toString()) : <Stack />}
      {assetCount ? renderInfo('Ativos', assetCount.toString()) : <Stack />}
      {renderInfo('Valor enviado', requestedAmount)}
      {renderInfo('Data de envio', orderDate)}
      {renderInfo('Canal de envio', notificationChannels)}
    </HStack>
  );
};
